/**
 * 等待多个 Promise 或异步函数执行完成
 */

function isPromiseLike(a) {
    return (a instanceof Promise) || (typeof a.then === 'function')
}

// 当 d.chain 中的所有 Promise resolve 后，执行 d.resolve()，
// d.chain 中任一个 Promise reject 后，立刻执行 d.reject()。
// 如果 d.chain 中包含函数（函数必须返回 Promise），则仅当上一个函数或 Promise resolve 
// 后才执行。
async function _waitAll(d) {
    d.index++
    if (d.index >= d.chain.length) {
        d.resolve(d.result)
        return
    }
    let promise = d.chain[d.index]
    if (typeof promise === 'function') {
        promise = promise.apply(this, [d.result])
        if (!isPromiseLike(promise)) {
            d.reject(
                'arguments[' + d.index + ']' +
                'is no return a promise')
            return
        }
    }
    else if (!isPromiseLike(promise)) {
        d.reject(
            'arguments[' + d.index + ']' +
            'is neither a promise nor a function')
        return
    }

    promise.then(x=>{
        d.result.push(x)
        _waitAll(d)
    }, x=>{
        d.reject(x)
    })
}

// 同时执行多个 API 调用，返回一个 Promise，
// 仅当所有 API 调用都成功后，此 Promise 才 resolve,
// 任何一个 API 调用失败，此 Promise 立刻 reject。
// 当参数中存在函数时，此函数必须返回一个 Promise 类型，
// 且，此函数只有在之前（参数顺序）的所有 Promise 都 resolve 后，才会调用，
// 调用函数时，以数组的形式传入之前所有 Promise 的结果。
// 参数:
//    ...args: Promise|Function
const waitAll = async function(promises, resultFilter) {
    let d = {}
    d.index = -1
    d.chain = promises || []
    d.result = []
    
    return new Promise(function (resolve, reject) {
        d.resolve = typeof resultFilter === 'function' ?
            x => resolve(resultFilter(x)) : resolve
        d.reject = reject
        _waitAll(d)
    })
}

export default waitAll